// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.slug {\n  margin-bottom: 0.75rem;\n}\n.slug.is-error {\n  border: 1px solid hsl(348deg, 100%, 61%);\n  border-radius: 4px;\n}\n.slug + .help {\n  margin-bottom: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
